angular.module('dnecom')
    .controller('ProductProcessLinkedController', ["$scope", function ProductProcessLinkedController($scope) {

        $scope.resetValues = function () {
            if ($scope.product.linkedProduct) {
                if (typeof $scope.product.properties.linkedData === 'undefined') {
                    $scope.product.properties.linkedData = {};
                }

                $scope.product.properties.linkedData.name = '';
                $scope.product.properties.linkedData.color = '#0099ff';

                $scope.product.linkedProduct.linkedName = '';
                $scope.product.linkedProduct.color = '#00cc00';
            }
        };

        $scope.products = jQuery.map(TemplateData.value('products'), function (product, idx) {
            var canLink = false;
            if (!product.linkedProduct) {
                canLink = true;
            }
            if (product.linkedProduct && $scope.product.linkedProduct) {
                canLink = product.id == $scope.product.linkedProduct.id;
            }

            return {id: product.id, name: product.name, canLink: canLink }
        });
    }]);
